module.exports = __webpack_public_path__ + "img/logo_on.c741413e.svg";